<template>
  <div>
    <div v-if="label" :class="$style.label" v-test="'base-button-list-label'">
      {{ label }}
    </div>
    <div v-if="error" :class="$style.error" v-test="'base-button-list-error'">
      *{{ $t('errors.selection_required') }}
    </div>
    <div :class="$style.inner">
      <div
        v-for="(option, index) in options"
        :key="index"
        :class="[$style.btn, { [$style.disabled]: option.disabled }]"
        :style="modelValue.includes(option.value) ? style : null"
        @click="onSelect(option)"
        v-test="`base-button-list-option`"
      >
        <BaseTooltip v-if="option.tooltip" :label="option.tooltip" />
        <div>{{ option.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTooltip from '@/components/BaseTooltip.vue';
import widgetSettings from '@/widget-settings';

export default {
  components: {
    BaseTooltip
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true,
      validator: (options) =>
        !options.find(
          (option) =>
            option.value === undefined || option.value === null || !option.label
        )
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    style() {
      return {
        'background-color': `${widgetSettings.color}30`,
        'box-shadow': 'none'
      };
    }
  },
  methods: {
    onSelect({ value, disabled }) {
      if (disabled) {
        return;
      }

      let newValue = [];

      if (this.modelValue.includes(value)) {
        newValue = this.modelValue.filter((valueItem) => valueItem !== value);
      } else {
        newValue = [...this.modelValue, value];
      }

      newValue.sort((a, b) => a - b);

      this.$emit('update:modelValue', newValue);
    }
  }
};
</script>

<style lang="scss" module>
.inner {
  display: flex;
  flex-wrap: wrap;

  & > *:not(:first-child) {
    margin-left: $spacing;
  }
}

.label {
  margin-top: $spacing;
}

.error {
  color: $color-error;
  font-size: 13px;
  margin-top: 4px;
}

.btn {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: white;
  border-radius: $border-radius;
  margin-top: $spacing;
  cursor: pointer;
  @include box-shadow;
  text-transform: capitalize;
}

.disabled {
  cursor: default;
  background-color: $color-bg;
}
</style>
